module.exports = __webpack_public_path__ + "static/media/marsreport.4c77354b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/PortfolioPage/images/marsreport.gif
// module id = 353
// module chunks = 0